import { useContext } from "react";
import { UserActions, UserSetupContextDispatch } from "components/Users/UserSetupContext";

export function useUserSetupActions(): UserActions {
    return useContext(UserSetupContextDispatch)!;
};

export default useUserSetupActions;
